import { observable, action, computed, reaction } from 'mobx';
import intl from 'react-intl-universal';
import EventEmitter from 'eventemitter3';
import { SUPPORT_FILE_EXTENSIONS } from 'Api/drives.constants'
import { message } from 'antd';
import { baseUrlApis, foxitSignApi, pluginStoreApi } from 'Api/index';
import { osName } from '../utils/browser-info';
import {
  getBrowserLanguage,
  getLanguageIsFollowSystem,
  getAppTitle,
  isPdfOnlineDomain,
  getQueryVariable,
  createPerformanceNode,
  storageSetItem,
  storageGetItem,
  getUserBgColor,
  prop,
  windowActionFn,
  isCanvas,
  isAISupported,
  NoAICountry
} from 'Utils/utils';
import zhCNLogo from '../assets/logo/zh-cn-logo.svg';
import enUSLogo from '../assets/logo/en-us-logo.svg';
import defaultLogo from '../assets/logo/logo.svg';
import { store } from './index';
import { DOC_SAVED } from 'Components/viewer/AIPlugin/constants'
import { EV_APP_ERROR } from "../app.config";
import { URL_CWS_API } from 'Api/constants';
import * as APP_CONSTANTS from 'Constants/app.constant';
import { COLLABORATION_HEADER, HOME_HEADER, COMMON_HEADER, COMMON_MODE, COLLABORATION_MODE } from '@/constants/index'
import { collaborationAnnotEvent, collaborationMqttService, collaborationService, localToGlobal/*, userService*/ } from 'Store/services/index'
// import { TemplatePluginController } from '../components/viewer/TemplatePlugin/index.js'
import { fileController } from "../components/viewer/Controllers/index";
import { CONVERT_FROM_TEMPLATE } from "../components/viewer/ui/constants/convert.constants";
import { disableCollaborationOnlyRead } from '@/utils/sdk_utils';
import { isMobile, isCNDomain, isJPDomain } from 'Utils/utils'
import { isTablet, isWindows, isMac } from 'Utils/device'
import { langs } from 'Utils/language'
import { HOME_BACK_TO_GETTING_STARTED } from '@/components/viewer/ui/constants/home.constants';
import {
  INSTALL_BUTTON_PACKAGE_DOWNLOAD,
  TOOLS_GA_EVENT_LABEL } from 'Components/viewer/ui/constants/tools.constants';
import { isForConvert } from 'Components/viewer/ui/constants/index';
import { TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW, TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL } from 'Components/viewer/ui/constants/user.more.constants';
import { DATA_TYPE } from "Api/constants";
import { USER_SIGN_IN_SUCCESS,LANG_CHANGE } from 'Store/constants';

import _throttle from "lodash/throttle";
import { collaborationAwsSqsService } from './services/Collaboration';
import { AllLocales } from '@/locales';
import i18nHashes from '../../temp/i18nHashes.js'
// import { isDTRuntime } from '@/modules/dingtalk/dingtalk.sdk';

function appendCommentListCommentCallback(commentComponent, annot) {
  if (/* store.collaborationStore.reviewSessionID */store.appStore.isCollaborationMode()) {
    const { userID, userName, avatar } = store.collaborationStore.getUserInfoByAnnotName(annot.info.name);
    let iconElement = commentComponent.iconElement;
    let avatarElement = commentComponent.avatarElement;
    // iconElement.className = 'fv__ui-commentlist-comment-icon';
    if (!avatar) {
      avatarElement.style.display = 'none';
      iconElement.style.display = 'flex';
      iconElement.style.background = getUserBgColor(userID);
      if (userName) {
        iconElement.innerHTML = userName[0].toUpperCase();
      }
    } else {
      iconElement.style.display = 'none';
      avatarElement.style.display = 'flex';
      avatarElement.setAttribute('src', avatar);
    }
    let typeElement = commentComponent.typeElement;
    typeElement.style.display = 'block'
  }
}
class AppStore {
  constructor() {
    this.onBeforeInstallPromptEvent = this.onBeforeInstallPromptEvent.bind(this);
    this.onAppInstalled = this.onAppInstalled.bind(this);
    this.onThrottle_NotifyOffline = this.onThrottle_NotifyOfflineWrapper();
    // 偏好设置窗口初始默认参数
    this.preferencesDefaultData = {
      // Scanned Document Editing Settings 设置窗口默认初始数据
      ScannedDocumentSettingDefaultData: {
        languages: ['English'],
        useSystemFont: true,
        makeAllPages: false
      },
      // Editing 设置窗口默认初始数据
      EditingDefaultData: {
        showChange: false,
        color: 'red',
        indentUnit: '0.33',
        alert: true,
        recognize: false
      }
    }
    this.allLocales = AllLocales;
  }
  signinReaction = null
  @observable notificationMessageArr = []

  /**
   * SharePoint Information.
   * @typedef {Object} SharePointInfo
   * @property {boolean} isFromSharePoint - Indicates if the operation is performed from SharePoint.
   * @property {string|null} fromDrive - The source drive name in SharePoint.
   * @property {boolean} sharepointFileCombinedSuccess - Indicates if the SharePoint file combination was successful.
   * @property {boolean} sharepointFileConvertSuccess - Indicates if the SharePoint file conversion was successful.
   * @property {string} backToSharePointUrl - The URL to navigate back to SharePoint.
   * @property {string|null} action - The action being performed in SharePoint.
   */

  /**
   * Observable object representing SharePoint information.
   * @type {SharePointInfo}
   */
  @observable sharePointInfo = {
    isFromSharePoint: false,
    fromDrive: null,
    sharepointFileCombinedSuccess: false,
    sharepointFileConvertSuccess: false,
    backToSharePointUrl: '',
    action: null,
  }
  @observable googleDriveInfo = {
    isFromGoogleDrive: false,
    isConverted: false,
  }
  @observable preventDocModifiedFlag = false
  @observable platform = 'PhantomOnline'
  @observable FoxitEU = 'Foxit PDF Editor Education'
  @observable beforeInstallPWAsEvent = null;
  @observable PWAsInstallStatus = APP_CONSTANTS.PWA_INSTALL_STATUS.start;// 'start' 'intalling' 'installed' 'cancel'
  @observable isDisableAccessQuicklyPDF = true
  @observable collaborationModeClassName = ''
  @observable oneDriveFileHandlerFileArr = []
  @observable onShowToDoDlg = null;
  @observable onShowWarningMessage = null;
  @observable onShowToSaveBeforeOpen = null
  @observable openLocalFile = null
  @observable saveToLocalComputer = null
  @observable saveToTeamsApp = null
  @observable currentMode = COMMON_MODE
  @observable headerType = HOME_HEADER;
  @observable logoTitleUseImg = true;
  @observable loginInNewWindow = true;
  @observable osName = osName;
  // TODO FOXIT 云编辑地址常量配置
  @observable cloudEditOrigin = window.location.origin
  
  @observable isDisableButton = null;
  @observable commonForSaveDrives = null;
  @observable isOnline = true;
  @observable doShowEditorLoading = null;
  @observable doHideEditorLoading = null;
  @observable showSaveAsDialogCNArea = false;
  @observable isZendeskWidgetLoaded = false;
  @observable serviceModeOfClientInfo = null;
  @observable cloudOnlineStorage = null;
  @observable currentClickBtnName = null
  @observable convertHtml2PDFFn = null;
  @observable onAddCurrentDocForCombineFilesFn = null;
  @observable onAddDocForCombineFilesFn = null;
  @observable onCovertFileForPreviewFn = null;
  @observable onCloseMulFilesDlgFn = null;
  @observable enterpriseSetting = null;
  @action initEnterpriseSettingInfo() {
    this.enterpriseSetting = null;

    this.enterpriseSetting = null;
    if (isCNDomain() || !store.userStore.isEnterpriseUser) {
      return Promise.resolve();
    }

    return baseUrlApis.getEnterpriseSetting(store.userStore.roleInfo.enterpriseId).then(
      data => {
        this.enterpriseSetting = { ...data };

        const {disableFeatures} = data;

        const userFlag = +(localStorage.getItem('aiUIFlag')||'3');

        if(disableFeatures.indexOf('AiAssistant')>-1){
            store.appStore.setAIUIFlag(userFlag&0b10);
        }else{
            let showAIFlag = (userFlag&0b10) + 1;

            store.appStore.setAIUIFlag(showAIFlag);
        }

        return Promise.resolve(this.enterpriseSetting);
      },
      error => {
        return Promise.reject(error);
      }
    );
  }
  @action updateCurrentClickBtnName(btnName) {
    this.currentClickBtnName = btnName
  }
  @action resetCurrentClickBtnName() {
    this.currentClickBtnName = null
  }
  @action setServiceModeOfClientInfo(serviceModeOfClientInfo) {
    if (serviceModeOfClientInfo) {
      let { fileUrl, ...remain } = serviceModeOfClientInfo;
      let lastColonIndex = fileUrl.lastIndexOf(':');
      let port = fileUrl.slice(lastColonIndex + 1).replace('/', '');
      let baseUrl = fileUrl.slice(0, lastColonIndex);
      this.serviceModeOfClientInfo = {
        fileUrl,
        port,
        baseUrl,
       ...remain
      }
    } else {
      this.serviceModeOfClientInfo = null;
    }
  }
  @action setZendeskWidgetLoaded(isZendeskWidgetLoaded) {
    this.isZendeskWidgetLoaded = isZendeskWidgetLoaded;
  }
  @action pushNotificationMessageArr(message) {
    this.notificationMessageArr.push(message)
  }
  @action removeNotificationMessageArr(notificationId) {
    this.notificationMessageArr = this.notificationMessageArr.filter((item) => {
      return item.notificationId !== notificationId
    })
  }
  @action spliceNotificationMessageArr(index, deleteCount) {
    this.notificationMessageArr.splice(index, deleteCount)
  }
  @action resetNotificationMessageArr() {
    this.notificationMessageArr = []
  }
  @action updatePreventDocModifiedFlag(value) {
    this.preventDocModifiedFlag = value
  }
  @action updateSharePointInfo(info) {
    Object.assign(this.sharePointInfo, info)
  }
  @action resetSharePointInfo() {
    this.sharePointInfo = {
      isFromSharePoint: false,
      fromDrive: null,
      sharepointFileCombinedSuccess: false,
      sharepointFileConvertSuccess: false,
      backToSharePointUrl: '',
      action: null
    }
  }
  @action updateGoogleDriveInfo(info) {
    Object.assign(this.googleDriveInfo, info)
  }
  @action resetGoogleDriveInfo() {
    this.googleDriveInfo = {
      isFromGoogleDrive: false,
      isConverted: false,
    }
  }
  @observable signChinaStampTotal = 0;

  @action updatePlatform(value) {
    this.platform = value
  }
  @action updateCollaborationModeClassName(value) {
    this.collaborationModeClassName = value
  }
  @action updateOneDriveFileHandlerFileArr(fileArr) {
    this.oneDriveFileHandlerFileArr = fileArr
  }
  @computed get isShowAccessQuicklyPDF() {
    const PluginInstall = getQueryVariable('PluginInstall');
    const { beforeInstallPWAsEvent, PWAsInstallStatus } = this;
    // 有install按钮，卡片显示未安装可点击，没有install按钮，卡片显示已经安装，且不能点击
    const isShowAccessQuicklyPDF = (beforeInstallPWAsEvent && PWAsInstallStatus !== APP_CONSTANTS.PWA_INSTALL_STATUS.cancel) || PluginInstall;

    return isShowAccessQuicklyPDF
  }
  @computed get isPWAInstalled() {
    let isPWAInstalledFromLocalStorage = false;
    let _IsPWAInstalled = storageGetItem(localStorage, 'IsPWAInstalled');
    try {
      isPWAInstalledFromLocalStorage = JSON.parse(_IsPWAInstalled);
    } catch (error) {
      isPWAInstalledFromLocalStorage = false;
    }
    return this.PWAsInstallStatus === APP_CONSTANTS.PWA_INSTALL_STATUS.installed || isPWAInstalledFromLocalStorage;
  }
  @computed get isFromShareLink() {
    const reviewSessionID = getQueryVariable('reviewSessionID')
    const fileLink = getQueryVariable('docUrl')
    const fileName = getQueryVariable('fileName')

    if (!(reviewSessionID && fileLink && fileName)) {
      return false
    }
    return true
  }
  @computed get isFromServiceModeOfClient() {
    if (this.serviceModeOfClientInfo) return true;
    const serviceMode = getQueryVariable('service_mode');
    const fileUrl = getQueryVariable('fileurl');
    const fileName = getQueryVariable('filename');
    const filePath = getQueryVariable('filepath');

    if (serviceMode === 'client' && fileUrl && fileUrl.search('http://localhost') !== -1 && (fileName || filePath)) {
      return true;
    }
    return false;
  }
  @computed get isIOS() {
    return this.osName && this.osName.indexOf('iOS') !== -1;
  }
  @computed get isMacOS() {
    return this.osName && this.osName.indexOf('mac') !== -1;
  }
  @computed get getSupportFileExtensions() {
    const result = SUPPORT_FILE_EXTENSIONS.map((item) => {
      return `.${item}`
    }
    )

    return result.join(',')
  }
  @computed get isWindowsOS() {
    if (!this.osName) return true;
    return this.osName && this.osName.indexOf('windows') !== -1;
  }
  @computed get isChromeOS() {
    return this.osName && this.osName.indexOf('chrome') !== -1;
  }
  @observable progressingInfo = { show: false, msg: '', percent: 10, intervalId: null };
  @observable loadingMessage = { show: false, msg: '' };
  @observable viewerEventEmitter = null;
  @observable appEventEmitter = new EventEmitter();
  @observable docModified = false;
  docModifiedCounts = 0;
  @observable.ref lng = getBrowserLanguage();
  @observable isFollowSystem = getLanguageIsFollowSystem();
  @observable closeMessageCenterDlg = null;
  @observable.ref addMessage = null;
  @observable showDocFormInfo = true;
  @observable verifySignatureRule = {};
  @observable pdfSignConfig = {
    isDisableFoxitEsignService: false,
    isFlatteDocumentWhenApplyingAllSignatures: false
  };
  @computed get isCN() {
    return this.lng.full === 'zh-CN';
  }
  @observable loading = true;
  @observable phantomOnlineGlobalConfig = null;
  // undefined.
  @observable environmentName = void 0;
  @computed get deployMode() {
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    return this.phantomOnlineGlobalConfig.deployMode;
  }

  @computed get isOnPremiseDeployMode() {
    return ("on-premise" === this.deployMode);
  }

  /**appStoreApiUrl:https://appstore-fz02.connectedpdf.com */
  @computed get appStoreUrl() {
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    return this.phantomOnlineGlobalConfig.appStoreApiUrl;
  }
  @computed get cwsApiUrl() {
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    return this.phantomOnlineGlobalConfig.cwsApiUrl;
  }
  @computed get accountUrl() {
    return '';
  }
  @computed get onlineCAUrl() {
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    return this.phantomOnlineGlobalConfig.onlineCAUrl;
  }
  @computed get onlineEUUrl() {
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    return this.phantomOnlineGlobalConfig.onlineEUUrl;
  }
  @computed get onlineUSUrl() {
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    return this.phantomOnlineGlobalConfig.onlineUSUrl;
  }
  @computed get usApi() {
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    return this.phantomOnlineGlobalConfig.usApi;
  }
  @computed get foxitPayChinaUrl() {
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    return this.phantomOnlineGlobalConfig.foxitPayChinaUrl;
  }
  @observable appLogo = null;
  @observable appTitle = null /*getAppTitle()*/;
  @observable isCustomLogo = false;
  @observable appTitleForXX = null;

  @observable isShowMessageDlg = false;
  @observable isUploadDocToAiPlugin = true;
  @observable messageDlgCfg = {};

  /**
   * @typedef {import('Components/viewer/AIPlugin/AiPluginDocFns.js').FileInfo} FileInfo
   */
  /**
   *
   *
   * @callback resolveFileListToAiPlugin
   * @param {FileInfo[]} files
   */
  @observable openFileDlg = {
    isShow: false,
    isForAi: false,
    activeMenuKey: '0',
    doChangeLoadingState: () => { },
    resolveFileListToAiPlugin: () => { },
  };
  @observable isShowHomeStart = !isMobile();
  @observable isShowShareErrorMask = false;  // 显示分享链接失效蒙层

  @observable isShowCollaborationViewerDom = false

  @observable isShowTemplateDlg = false;
  @observable templateId = null;
  @observable MessageStore = {
    isShow: false,
  }
  @observable TipsMsg = {
    isShow: false,
    content: null,
    type: 'success'
  }
  @observable homeTabActive = null
  @observable disableMessageCenterDlg = false;
  // outputLog('error', 'some error:', error)
  @action outputLog(type, ...params) {
    prop(console, type) && prop(console, type)(...params);
  }
  @action outputInfoLog(...params) {
    prop(console, 'log') && prop(console, 'log')(...params);
  }
  @action outputErrorLog(...params) {
    prop(console, 'error') && prop(console, 'error')(...params);
  }
  @action outputWarnLog(...params) {
    prop(console, 'warn') && prop(console, 'warn')(...params);
  }
  @action tipsAlert({ isShow, content, type }) {
    this.TipsMsg = {
      isShow: isShow || false,
      content: content || null,
      type: type || 'success'
    }
    setTimeout(() => {
      this.TipsMsg.isShow = false
    }, 3000)
  }
  @action updateTemplateId(value) {
    this.templateId = value;
  }
  @action updateIsShowCollaborationViewerDom(value) {
    if (isMobile()) value = false;
    this.isShowCollaborationViewerDom = value
  }
  @action updateShowHomeStart(value) {
    if (isMobile()) value = false;
    this.isShowHomeStart = value
  }
  @action updateShowShareErrorMask(value) {
    this.isShowShareErrorMask = value
  }
  @action updateShowTemplateDlg(value) {
    this.isShowTemplateDlg = value
  }
  @action setHomeHeader() {
    this.headerType = HOME_HEADER
  }
  @action setCommonHeader() {
    this.headerType = COMMON_HEADER
  }
  @action setCollaborationHeader() {
    this.headerType = COLLABORATION_HEADER
  }
  @action setOpenFileDlgChangeLoadingState(callback) {
    this.openFileDlg.doChangeLoadingState = callback;
  }
  @action showOpenFileDlg(isForAi, driveName, callback) {
    this.openFileDlg = {
      isShow: true,
      isForAi,
      activeMenuKey: driveName,
      doChangeLoadingState: () => { },
      resolveFileListToAiPlugin: callback,
    };
  }
  @action hideOpenFileDlg(msgType) {
    const msgMap = {
      success: intl.get('OpenFileForPanel.UploadSuccess'),
      error: intl.get('OpenFileForPanel.UploadFailed'),
    };

    this.openFileDlg = {
      isShow: false,
      isForAi: false,
      activeMenuKey: '0',
      doChangeLoadingState: () => { },
      resolveFileListToAiPlugin: () => { },
    };

    if (msgType) {
      const msg = {
        type: msgType,
        content: msgMap[msgType],
      };

      this.setGlobalMessage(msg);
    }
  }
  @action showMessageDlg({ msg }) {
    if (!msg) {
      this.isShowMessageDlg = false;
      this.messageDlgCfg = {};
      return;
    }
    this.isShowMessageDlg = true;
    this.messageDlgCfg = {
      msg: msg,
      onOk: () => {
        this.isShowMessageDlg = false;
      },
    };
  }
  @action showMessageDlgEx({ message, title, ok, cancel, closable, checkbox }, noClose, callback, closeCallback) {
    const messageDlgCfg = Object.assign(
      {},
      {
        msg: { id: message, title, ok, cancel, closable, checkbox },
        onOk: (state) => {
          callback && callback(true, state);
          this.isShowMessageDlg = false;
          return true;
        },
        onClose: !noClose
          ? () => {
            closeCallback && closeCallback()
            this.isShowMessageDlg = false;
            return false;
          }
          : void 0,
      },
    );
    this.isShowMessageDlg = true;
    this.messageDlgCfg = messageDlgCfg;
  }

  /**{
   *  title, info, button
   * },
   *
   * can be null to hide dialog
   *  */
  @observable noticeDialog = null;
  /**
   * global modal config
   */
  @observable globalModalConfig = { visible: false };
  @action async changeLanguage(lang) {

    let language;
    if (langs[lang] !== void 0) {
      language = langs[lang];
      store.userStore.doSendGAEventByUser({ eventKey: language.gaName, label: 'upper_right_area' });
    }

    await this.loadLocales(language)


    this.lng = language;
    if (window.pdfui) {
      this.doAddResourceBundle(pdfui);
      window.pdfui.changeLanguage(this.lng.full);
    }
    if (this.logoTitleUseImg) {
      if (this.lng.full === 'zh-CN') {
        this.appLogo = zhCNLogo;
      } else {
        this.appLogo = enUSLogo;
      }
    }

    if (!isMobile() && !this.isOnPremiseDeployMode && !isCNDomain() && !isJPDomain()&&!isCanvas()) {
      if (typeof zE === 'function' && this.isZendeskWidgetLoaded) {
        this.setZendeskWidgetLocale();
      }
    }

    //storage lang
    storageSetItem(localStorage, 'language', this.lng.full);
    store.appStore.emitEvent(LANG_CHANGE);

    if (prop(location, 'pathname') === '/') {
      this.isShowFromTemplate()
    }
  }
  @action setZendeskWidgetLocale() {
    let lng = this.lng.full;
    try {
      zE('webWidget', 'setLocale', lng); // support
    } catch (error) {
      zE('messenger:set','locale', lng); // live chat
    }
  }
  @action changeFollowSystemLng(isFollowSystem, lang) {
    this.isFollowSystem = isFollowSystem
    //storage lang
    storageSetItem(localStorage, 'isSystemlanguage', isFollowSystem);
    if (isFollowSystem) {
      storageSetItem(localStorage, 'language', null);
      const lng = getBrowserLanguage()
      this.changeLanguage(lng.lang)
    } else {
      this.changeLanguage(lang)
    }
  }
  
  /**
   * Updates the progressing information.
   * @param {boolean} show - Whether to show the progressing information or not.
   */
  @action updateProgressingInfo(show) {
    let percent = 10;
    let intervalId;
    const { loadingMessage: { show: isShowGlobalLoading } } = this

    // If the global loading is shown, the progressing information should replace it.
    if (show === true && isShowGlobalLoading === true) {
      this.showLoading(false)
    }
      
    if (show === true && !this.progressingInfo.show) {
      this.progressingInfo = Object.assign({}, this.progressingInfo, { show });
      intervalId = setInterval(() => {
        const getDenominator = () => {
          if (percent < 20) {
            return 1
          }

          if (percent < 80) {
            return 5
          }

          if (percent < 90) {
            return percent
          }     
          
          if (percent < 100) {
            return 10000
          }
        }
        
        if (percent >= 99) {
          percent += 0;
        } else {
          percent += (Math.random() * 10) / getDenominator();
        }
        this.progressingInfo = Object.assign({}, this.progressingInfo, { percent });
      }, 100);
      this.progressingInfo = Object.assign({}, this.progressingInfo, { intervalId });
    }
    
    if (show === false) {
      clearInterval(this.progressingInfo.intervalId);
      this.progressingInfo = { show: false, percent: 10, intervalId: null };
    }
  }
  @action showLoading(show) {
    const { progressingInfo: { show: isShowProgress } } = this;

    // If the progressing information is shown, the loading information will replace it.
    if (show === true && isShowProgress === true) {
      this.updateProgressingInfo(false)
    }

    this.loadingMessage = { show };
  }
  @action fetchRegularFont() {
    baseUrlApis.fetchRegularFont();
  }
  @action showWaitingForSignIn(isShow, flag) {
    const { progressingInfo: { show: isShowProgress } } = this;

    // If the progressing information is shown, the loading information will not show.
    if (isShow === true && isShowProgress === true) {
      isShow = false
    }

    if (!isShow) {
      this.loadingMessage = { show: false, msg: '' };
      return;
    }
    if (flag !== 'sign-up') {
      this.loadingMessage = { show: true, msg: 'user.signInWaiting' };
      return;
    }
    this.loadingMessage = { show: true, msg: 'user.signUpWaiting' };
  }
  @action showLoadingWithMsg({show, msg}) {
    const { progressingInfo: { show: isShowProgress } } = this;

    // If the progressing information is shown, the loading information will not show
    if (show === true && isShowProgress === true) {
      show = false
    }

    this.loadingMessage = {show, msg};
  }
  @action doUpdateDocModified(status, isSaved) {
    if (status === true && this.preventDocModifiedFlag === true) {
      return
    }
    this.docModified = status;
    if (status) {
      this.doUpdateDocModifiedCounts(this.docModifiedCounts + 1)
    }
    !!isSaved && this.doNoticeMessage(DOC_SAVED);
    !!isSaved && this.doNoticeMessage(APP_CONSTANTS.COLLECT_NPS_SURVEY);

    if (status && !this.isFromServiceModeOfClient) { // 本地双击打开模式不弹出
      window.onbeforeunload = function (e) {
        e = e || window.event;

        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = '关闭提示';
        }

        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return '关闭提示';
      };
    } else {
      window.onbeforeunload = null
    }
  }

  doUpdateDocModifiedCounts(count) {
    this.docModifiedCounts = count;
  }

  /**
   * @param {*} msg
   * @param {string} msg.type which can be one of "success", "error", "info", "warning"
   * @param {string} msg.content the message to display
   * @param {string} msg.duration which time to close message box
   * @memberof AppStore
   */
  @action setGlobalMessage(msg) {
    if (msg.type === 'error' && store.teamsAppStore.inTeamsApp) {
      store.teamsAppStore.loading.show({progress: 100});
    }
    const key = 'msg_global';
    const { type, content, duration, onClose = () => { } } = msg;
    let _duration = !duration ? 5 : duration;
    message[type]({ content, duration: _duration, key, onClose });
  }

  /**
   * open modal -> {visible: true, title: xxx, children: (xxx), ...}
   * close modal -> {visible: false}
   */
  @action setGlobalModalConfig(config = {}) {
    if (config.visible) {
      this.globalModalConfig = Object.assign(
        {
          destroyOnClose: true,
          okText: intl.get('Ok'),
          cancelText: intl.get('Cancel'),
          onOk: () => {
            this.setGlobalModalConfig({ visible: false });
          },
          onCancel: () => {
            this.setGlobalModalConfig({ visible: false });
          },
        },
        config,
      );
    } else {
      this.globalModalConfig = Object.assign({}, this.globalModalConfig, { visible: false });
    }
  }

  @action doUpdateSignInNotice(dlgInfo) {
    this.noticeDialog = dlgInfo;
  }
  @action doNotifyErrors(errCode) {
    switch (errCode) {
      case 100010:
        // 接口凭据过期，发起token更新
        store.userNewStore.getToken()
        this.doUpdateSignInNotice({ id: 'Error.100010' });
        // const isHideNotifyErrors = userService.isHideNotifyErrors
        // const vTest = baseUrlApis.getQueryVariable("mock");
        // if (vTest === 'user') {
        //   break;
        // }
        // if (isDTRuntime) {
        //   break;
        // }
        // store.userStore.clean(true);
        // store.taskStore.setTaskMessage(null);

        // if (!isHideNotifyErrors){
        //   this.doUpdateSignInNotice({ id: 'Error.100010' });
        //   store.userStore.hidePopupSignUpOrSignIn()
        // }
        break;
      case 'offline':
        //
        this.onThrottle_NotifyOffline();
        break;
      default:
        break;
    }
  }
  onThrottle_NotifyOfflineWrapper(){
    //this.fn_flag++
    return _throttle(() => {
      //store.userStore.clean();
      store.taskStore.setTaskMessage(null);
      // this.onShowWarningMessage(null, { message: 'Error.offline' }, true)
      message.error(intl.formatMessage({ id: 'Error.offline' }))
      //this.doUpdateSignInNotice({ id: 'NetworkError' });
    }, 5000, {
      leading: true,
      trailing: false
    })
  }
  @action setViewerEventEmitter(emitter) {
    this.viewerEventEmitter = emitter;
  }

  @action addAppEventListener(ev, listener) {
    this.appEventEmitter.on(ev, listener);
  }
  @action removeAppEventListener(ev, listener) {
    this.appEventEmitter.removeListener(ev, listener);
  }
  @action emitEvent(ev, data) {
    this.appEventEmitter && this.appEventEmitter.emit(ev, data);
  }
  @action doNoticeMessage(msg) {
    // to app
    this.appEventEmitter && this.appEventEmitter.emit(msg);
    // to viewer
    this.viewerEventEmitter && this.viewerEventEmitter.emit(msg);
  }

  @action updateLoading(value) {
    this.loading = value;
  }
  @action doListenPWAsEvents() {

    // Listen for beforeinstallprompt events, indicating Squoosh is installable.
    window.addEventListener('beforeinstallprompt', this.onBeforeInstallPromptEvent);
    // Listen for the appinstalled event, indicating Squoosh has been installed.
    window.addEventListener('appinstalled', this.onAppInstalled);
    this.doListenOpenFileByUWP()
  }
  doListenOpenFileByUWP() {
    // const notShowPwaDlgAgain = this.getLocalStorage('notShowPwaDlgAgain');
    // if(isWindows && window.matchMedia('(display-mode: minimal-ui)').matches && !notShowPwaDlgAgain){
    //   this.setIsShowPwaTips(true)
    // }
    if (window.Windows) {
      Windows.UI.WebUI.WebUIApplication.addEventListener('activated', function (activatedEventArgs) {
        if (activatedEventArgs.kind === Windows.ApplicationModel.Activation.ActivationKind.file) {
          store.viewer.doOpenFile({ file: activatedEventArgs.files[0], dataType: DATA_TYPE.StorageFile });
        }
      });
      return;
    }
    if ('launchQueue' in window) {
      launchQueue.setConsumer((launchParams) => {
        // Nothing to do when the queue is empty.
        if (!launchParams.files.length) {
          return;
        }
        let fileHandle = launchParams.files[0];
        //
        fileHandle.getFile().then((file) => {
          store.viewer.doOpenFile({ file: file, dataType: DATA_TYPE.File });
        })
      });
      return;
    }
  }
  onBeforeInstallPromptEvent(event) {
    // Don't show the mini-infobar on mobile
    // Save the beforeinstallprompt event so it can be called later.
    // if(this.PWAsInstallStatus === PWA_INSTALL_STATUS.cancel ){
    //   return;
    // }
    event.preventDefault();

    if (isMobile()) return;
    if (isTablet) return;

    //return;

    this.beforeInstallPWAsEvent = event;
    this.setIsDisableAccessQuicklyPDF(false);
    storageSetItem(localStorage, 'IsPWAInstalled', false);

    /* setTimeout(() => {
      this.beforeInstallPWAsEvent = null;
    }, 10000); */
  }
  onAppInstalled() {
    // We don't need the install button, if it's shown
    // Clear the install method property
    this.beforeInstallPWAsEvent = null;
    this.setIsDisableAccessQuicklyPDF(false);
    this.PWAsInstallStatus = APP_CONSTANTS.PWA_INSTALL_STATUS.installed;
    storageSetItem(localStorage, 'IsPWAInstalled', true);

    // Don't log analytics if page is not visible
    if (document.hidden) return;

  }

  @action setIsDisableAccessQuicklyPDF(value) {
    this.isDisableAccessQuicklyPDF = value;
  }

  // Event
  @action doInstallPWAs(/* event */) {
    // If there's no deferred prompt, bail.
    if (!this.beforeInstallPWAsEvent)
      return;

    this.PWAsInstallStatus = APP_CONSTANTS.PWA_INSTALL_STATUS.installing;
    // Show the browser install prompt
    this.beforeInstallPWAsEvent.prompt();

    // Wait for the user to accept or dismiss the install prompt
    this.beforeInstallPWAsEvent.userChoice.then((result) => {
      const { outcome } = result;
      // outcome === 'accepted' ? 1 : 0,
      if (outcome !== 'dismissed') {
        this.beforeInstallPWAsEvent = null;
        this.PWAsInstallStatus = APP_CONSTANTS.PWA_INSTALL_STATUS.installed;
        storageSetItem(localStorage, 'IsPWAInstalled', true);
        // if(isWindows ){
        //   this.setIsShowPwaTips(true)
        // }
      } else if (outcome === 'dismissed') {
        // If the prompt was dismissed, we aren't going to install via the button.
        this.PWAsInstallStatus = APP_CONSTANTS.PWA_INSTALL_STATUS.start;
      }

    });
  };
  @action initGlobalConfig(cfg) {
    // Note: 'update isLoading' need to be in first
    store.isLoading = false;
    this.phantomOnlineGlobalConfig = cfg;
    if (this.phantomOnlineGlobalConfig.environmentName) {
      this.environmentName = this.phantomOnlineGlobalConfig.environmentName;
    }
    this.lng = getBrowserLanguage();

    //
    this.initialize();
    store.userStore.initialize();
    store.taskStore.initialize();
    store.accountStore.initialize();
    store.teamsAppStore.initialize();
    store.pluginStore.initialize();
    store.iDoxStore.initialize();
    store.storageAppStore.initialize();

    if (this.phantomOnlineGlobalConfig && this.phantomOnlineGlobalConfig.shareNoticeType === 'sns') {
      this.phantomOnlineGlobalConfig.awsRegion && collaborationAwsSqsService.initial(this.phantomOnlineGlobalConfig.awsRegion)
    }
    if(isCNDomain()){
        this.showLittleHelper(false);
    }
  }
  @action initialize() {
    // !jeager分布式跟踪启动
    // jaegerApi.initJaeger(this.phantomOnlineGlobalConfig.jaegerBaseUrl);

    //OnPremise获取企业logo和name配置
    if (this.isOnPremiseDeployMode) {
      store.userStore.getDrivesConfig({
        enterprise_id: '',
        success: (result) => {
          const { cloudOnlineLogo, cloudOnlineName, cloudOnlineStorage } = result.message;
          this.setAppInfo(cloudOnlineLogo, cloudOnlineName);
          this.setCloudOnlineStorage(cloudOnlineStorage);
        },
        fail: (/*res*/) => { },
      })
      return;
    }

    let distributorName = store.accountStore.getDistributorName();
    distributorName && this.setAppInfoForXX(distributorName);
  }
  @computed get pheeAdminUrl() {
    if (this.phantomOnlineGlobalConfig) {
      return this.phantomOnlineGlobalConfig.pheeAdminUrl;
    }
    return '';
  }
  @computed get foxitAiPluginUrl() {
    if (this.phantomOnlineGlobalConfig) {
      return this.phantomOnlineGlobalConfig.idoxAIPluginUrl;
    }
    return '';
  }
  @computed get foxitAiUrl() {
    if (this.phantomOnlineGlobalConfig) {
      return this.phantomOnlineGlobalConfig.idoxAiUrl;
    }
    return '';
  }
  @action async getAppLogoAsync() {
    // request php to get customized logo to be done
    if (!this.appLogo) {
      if (this.lng.full === 'zh-CN') {
        this.appLogo = zhCNLogo;
      } else {
        this.appLogo = enUSLogo;
      }
    }
  }
  @action setAppTitle(title) {
    if (title) document.title = title;
    else {
      if (!this.appTitle) this.appTitle = getAppTitle();
      document.title = this.appTitle;
    }
  }
  @action updateAppTitle() {
    if (!this.isShowHomeStart) return ;
    if (this.appTitleForXX) {
      let szValue = intl.get('PhantomPDF.Online.AppTitleForXX', { name: this.appTitleForXX });
      this.setAppTitle(szValue);
    } else if (this.isCustomLogo) {
      this.setAppTitle(this.appTitle + ' ' + intl.get('PhantomPDF.Online.Title') + (isPdfOnlineDomain() ? '' : intl.get('PhantomPDF.Online.Online')));
    } else {
      this.setAppTitle(getAppTitle());
    }
  }
  // @action updateHtmlInfo(){
  //   let title = intl.get('PhantomPDF.Online.htmlTitle');
  //   let htmlDescription = intl.get('PhantomPDF.Online.htmlDescription');
  //   document.title = title;
  //   let metaList = document.getElementsByTagName("meta");
  //   metaList.forEach(item=>{
  //     if(item.name === 'description'){
  //       item.content = htmlDescription
  //     }
  //   })
  // }
  @action setAppInfo(logo, title) {
    if (!logo && !title) {
      this.logoTitleUseImg = true;
      return;
    }
    this.isCustomLogo = true;
    this.logoTitleUseImg = false;
    if (!logo) {
      logo = defaultLogo;
    }
    this.appLogo = logo;
    this.appTitle = title;
    let szValue = title + ' ' + intl.get('PhantomPDF.Online.Title') + (isPdfOnlineDomain() ? '' : intl.get('PhantomPDF.Online.Online'));
    this.setAppTitle(szValue);
  }

  @action setAppInfoForXX(name) {
    this.appTitleForXX = name
    this.isCustomLogo = false;
    this.logoTitleUseImg = false;
    this.appLogo = defaultLogo;
    let szValue = intl.get('PhantomPDF.Online.AppTitleForXX', { name: this.appTitleForXX });
    this.setAppTitle(szValue);
  }

  @observable isShowLittleHelperTips = false;
  @observable msg_LittleHelperTips = {
    type: 'message',
    title: null,
    content: null,
  };

  /**
   * @method showMessage
   * @param {Object} params
   * @param {String} params.type one of 'message' 'notification', default use 'message'
   * @param {String} params.duration times
   * @param {Object} params.title (optional)
   * @param {String} params.title.text
   * @param {String} params.title.iconType
   * @param {Object} params.content
   * @param {String} params.content.iconType (optional) one of 'success' 'error' 'warning' 'info', default use 'success'
   * @param {String} params.content.text
   * @param {Object} params.content.button (optional)
   * @param {String} params.content.button.text
   * @param {String} params.content.button.cb
   *
   */
  @action alertTips({ type, title, content, duration }) {
    const { foxitAiPluginUrl } = this;
    if (!foxitAiPluginUrl) {
      return;
    }
    duration === void 0 && (duration = 6);
    let tipsObj = { type, title, content };
    // begin
    const fn = () => {
      this.msg_LittleHelperTips = tipsObj;
      this.isShowLittleHelperTips = true;
      let handle = setTimeout(() => {
        clearTimeout(handle);
        this.isShowLittleHelperTips = false;
      }, duration * 1000);
    };

    if (this.isShowLittleHelper) {
      return fn();
    }

    if(!this.isCN){
        this.isShowLittleHelper = true;
    }
    let handle = setTimeout(() => {
      //需要1s 执行动画； 小助手进场完毕后   弹出tips
      clearTimeout(handle);
      fn();
    }, 1500);
  }
  @observable isShowLittleHelper = true; //是否躲藏
  @action showLittleHelper(isShow) {
    this.isShowLittleHelper = isShow;
  }
  @observable Ai_openFile = {
    isShow: false,
    cb: null,
  };
  @observable Template_openFile = {
    isShow: false,
    cb: null,
    isSave: ''
  };
  @action isShowTemplate_openFile(isShow, cb, isSave) {
    this.isSave = isSave
    if (isShow) {
      this.Template_openFile = { isShow, cb, isSave };
    } else {
      this.Template_openFile.isShow = false;
    }
  }
  @action isShowAi_openFile(isShow, cb) {
    if (isShow) {
      this.Ai_openFile = { isShow, cb };
    } else {
      this.Ai_openFile.isShow = false;
    }
  }
  @action setLocalStorage(key, value) {
    storageSetItem(localStorage, key, value);
  }
  @action getLocalStorage(key) {
    return storageGetItem(localStorage, key);
  }
  @action getUpdateLogs() {
    return baseUrlApis.getUpdateLogs();
  }

  @action getUpdateLog(fileName) {
    return baseUrlApis.getUpdateLog(fileName);
  }
  @action getFileUrlByTransferStation(url) {
    //https://pheecws-fzk8s.connectedpdf.com/cpdfapi/v1/client/transfer-station
    if (!this.phantomOnlineGlobalConfig) {
      return '';
    }
    //https://pheecws-fzk8s.connectedpdf.com/cpdfapi/v1/client/transfer-station?url=http://demo.test.com/DemoFile/test.txt
    let baseUrl = this.phantomOnlineGlobalConfig[URL_CWS_API];
    let fileUrl = `${baseUrl}/cpdfapi/v1/client/transfer-station?url=${encodeURIComponent(url)}&_=${Date.now()}`
    return fileUrl;
  }

  /* == monitor error begin == */
  @observable.ref monitorErrorConfig = null;
  @action onCatchAppError(config) {
    this.monitorErrorConfig = config;
    let names = this.appEventEmitter.eventNames();
    if (names.indexOf(EV_APP_ERROR) !== -1) {
      return;
    }
    this.appEventEmitter.on(EV_APP_ERROR, () => {
      if (!baseUrlApis.isInit()) {
        let h = setTimeout(() => {
          clearTimeout(h);
          this.appEventEmitter.emit(EV_APP_ERROR)
        }, 3000);
        return;
      }

      const errors = [...window.__errors__];
      if (errors.length === 0) {
        return;
      }
      window.__errors__ = [];

      // TODO FOXIT 去除接口请求：报错上传服务器。
      //  baseUrlApis.sendErrorLog(errors);

    })
  }
  /**
   * @param {Object} error
   * @param {String} error.level use 'error' by default, include "info", "warn", "error"
   * @param {String} error.category one of "js", "resource", "ajax", ...
   * @param {Object} error.data {url, message, stack, ...}
   *
   * { level: 'error', data: error.data, category:'js' }
  */
  @action doPostError(error) {
    this.monitorErrorConfig && this.monitorErrorConfig.sendError(error);
  }
  @observable.ref actions = [];
  @action doSaveAction(actionKey) {
    this.actions.push(actionKey);
    if (this.actions.length > 10) {
      this.actions.shift()
    }
  }
  @observable.ref performanceInfo = {};
  @observable.ref browserId = '';
  formatPerformanceData(){
    const keyValueFn = (endEvent, startEvent)=>{
      return {endEvent, startEvent};
    }
    const diffFn = (endEvent, startEvent) =>{
      let end = this.performanceInfo[endEvent];
      let start = this.performanceInfo[startEvent];
      if(end === void 0 || start === void 0) return '';
      return Math.floor((end - start)/1000 * 100) / 100;
    }
    /* const infoFn = (end, start)=>{
      start = start === APP_CONSTANTS.ONLINE_START_LOAD? 'input-url':start;
      end = end === APP_CONSTANTS.SDK_FINISH_LOAD? 'sdk-engine-loaded':end;
      return `${end} - ${start}`;
    } */
    let map = {
      [APP_CONSTANTS.HOME_PAGE_LOADED]:keyValueFn(APP_CONSTANTS.HOME_PAGE_LOADED, APP_CONSTANTS.ONLINE_START_LOAD), // home loaded
      [APP_CONSTANTS.SDK_START_LOAD]:keyValueFn(APP_CONSTANTS.SDK_START_LOAD, APP_CONSTANTS.ONLINE_START_LOAD), // start load sdk ui_extension files
      ['sdk-ui-start']:keyValueFn(APP_CONSTANTS.SDK_START_INIT, APP_CONSTANTS.ONLINE_START_LOAD), // start init sdk ui
      ['sdk-ui-finish']:keyValueFn(APP_CONSTANTS.SDK_FINISH_INIT, APP_CONSTANTS.SDK_START_INIT), // finish init sdk ui
      ['sdk-engine-loaded']:keyValueFn(APP_CONSTANTS.SDK_FINISH_LOAD, APP_CONSTANTS.SDK_START_LOAD),
      ['total-time']:keyValueFn(APP_CONSTANTS.SDK_FINISH_LOAD, APP_CONSTANTS.ONLINE_START_LOAD),
      [APP_CONSTANTS.SDK_RENDER_FIRST_PAGE]:keyValueFn(APP_CONSTANTS.SDK_RENDER_FIRST_PAGE, APP_CONSTANTS.SDK_BEFORE_OPEN_DOC),
      ['open-file-used-time']:keyValueFn(APP_CONSTANTS.SDK_RENDER_FIRST_PAGE, APP_CONSTANTS.USER_SELECT_FILE),
      ['collaboration-create-time-consumption']:keyValueFn(APP_CONSTANTS.COLLABORATION_FINISH, APP_CONSTANTS.COLLABORATION_START),
      ['collaboration-create-cpdf-time-consumption']:keyValueFn(APP_CONSTANTS.COLLABORATION_CPDF_FINISH, APP_CONSTANTS.COLLABORATION_CPDF_START),
      ['collaboration-file-upload-time-consumption']:keyValueFn(APP_CONSTANTS.COLLABORATION_FILE_UPLOAD_FINISH, APP_CONSTANTS.COLLABORATION_FILE_UPLOAD_START),
      ['collaboration-file-download-time-consumption']:keyValueFn(APP_CONSTANTS.COLLABORATION_FILE_DOWNLOAD_FINISH, APP_CONSTANTS.COLLABORATION_FILE_DOWNLOAD_START),
      ['collaboration-open-time-consumption']:keyValueFn(APP_CONSTANTS.COLLABORATION_OPEN_FINISH, APP_CONSTANTS.COLLABORATION_OPEN_START),
    }
    let data = {
      'time':{},
      'info':{...this.performanceInfo}
      //'means':{}
    };
    Object.keys(map).forEach((key)=>{
      let timeEvent = map[key];
      const {endEvent, startEvent} = timeEvent;
      if(this.performanceInfo[endEvent] === void 0 || this.performanceInfo[startEvent] === void 0) return;
      data['time'][key] = diffFn(endEvent, startEvent);
      //data['means'][key] = infoFn(endEvent, startEvent);
    })
    return data;
  }
  @action sendPerformanceInfo({/* id,*/ fileName,  time, event, lastEvent, isEmit}){
    if(!this.browserId){
      this.browserId = storageGetItem(localStorage, 'fx__browser_monitor_id')||new Date().getTime();
    }
    if(!time){
      time = Date.now();
    }

    this.performanceInfo[event] = time;
    // let start = this.performanceInfo[APP_CONSTANTS.ONLINE_START_LOAD];
    if(!isEmit){
      return;
    }
    let data = this.formatPerformanceData();
    if(lastEvent && isEmit){
      const vTest = getQueryVariable("test");
      if ( vTest === 'performance' && fileName) {
        createPerformanceNode('time-statistics', fileName, data);
        this.performanceInfo = {}
      }

      this.doPostError({
        level:'info',
        category:'performance',
        browserId:this.browserId,
        data
      })
    }


  }
  /* == monitor error begin == */

  @action switchToHandler() {
    //'ai-select-text'
    window.pdfui && window.pdfui.getStateHandlerManager().then(stateHandlerManager => {
      //const prevStateHandler = stateHandlerManager.getCurrentStates();
      stateHandlerManager.switchTo('ai-select-text');
      //_this.pdfViewer.eventEmitter.emit(Events.checkTheSearch, formatResult, prevStateHandler);
    });
  }
  @action requestFoxitSignSSOToken() {
    return foxitSignApi.requestSingleSignOnToken()
  }
  @action async backToHomeStart(type) {
    this.setCommonMode()

    //返回home时增加 是否保存 已修改文件弹窗
    this.emitEvent(APP_CONSTANTS.GO_TO_HOME_PAGE);

    store.collaborationStore.resetCollaborationData()
    store.collaborationStore.updateIsUploadedInitialAnnots(false)

    this.setHomeHeader()
    this.updateShowHomeStart(true)

    if(type!='normal'){
      this.setHomeHeader()
      this.updateShowHomeStart(true)
      store.viewer.changeFileState(false);
    }

    setTimeout(async () => {
      if(type=="normal"){
        if(fileController.fullFeature)return;

        fileController.getCurrentDocBuffer()
        .then(async (docStream)=>{
          await fileController.closeCurrentPDFDoc()
          store.appStore.viewerEventEmitter.emit('switchWorker',docStream);
        })
        return
      }
      await fileController.closeCurrentPDFDoc()
    }, 1000)

    store.taskStore.doCancelCurrentTask()
    store.userStore.doSendGAEvent({ eventKey: HOME_BACK_TO_GETTING_STARTED, label: 'home_tab' });
    store.historyStore.push({pathname:'/', search: store.teamsAppStore.locationSearch || ''})
    this.updateAppTitle();
  }
  @action isCollaborationMode() {
    return this.currentMode === COLLABORATION_MODE
  }
  @action async setCollaborationMode_noSignIn(){
    store.appStore.viewerEventEmitter.emit('changeToolBar', 'noSignIn')
    const commentTab = await pdfui.getComponentByName('comment-list-sidebar-panel')
    commentTab.addCSSClass('noSignIn')
    // const commentList = await pdfui.getComponentByName('commentlist-expend-annot-list')
    this.updateCollaborationModeClassName('online-collaboration guest-mode')
    store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS,
      () => {
        this.collaboration_signIn_update()
      }
    );
    // commentList.disable()
  }
  @action updateCollaborationClassByViewMode() {
    const currentViewMode = store.collaborationStore.getCurrentViewMode()

    if (currentViewMode === 'can view') {
      this.updateCollaborationModeClassName('online-collaboration can-view')
    } else if (currentViewMode === 'can comment') {
      this.updateCollaborationModeClassName('online-collaboration')
    }
  }
  @action async collaboration_signIn_update(){
    store.collaborationStore.updateOthersAnnotList_all();
    store.appStore.viewerEventEmitter && store.appStore.viewerEventEmitter.emit('changeToolBar', 'collaboration')

    const commentTab = await pdfui.getComponentByName('comment-list-sidebar-panel')

    commentTab.removeCSSClass('noSignIn')
    this.updateCollaborationClassByViewMode()

    window.pdfui.getAnnotAuthorityManager().then(authority=>{
      authority.updateAll()
    })
  }
  @action testAws() {
    awsSnsService.onMessage((data) => {
      console.log(data)
    })
  }
  @action async setCollaborationMode() {
    // const { emqttUrl, emqttWsPort, emqttWssPort } = this.phantomOnlineGlobalConfig
    // TODO FOXIT 修改mqtt接口：原云编辑使用emqttUrl="emqtt-cn.connectedpdf.com",emqttWsPort=8083,emqttWssPort=8084;云编辑修改为wss://mqtt.foxitcloud.cn
    const emqttUrl = "mqtt.foxitcloud.cn"
    // this.updateCollaborationModeClassName('online-collaboration')
    // if(this.currentMode == COLLABORATION_MODE)return;
    // TODO FOXIT 协同功能--toolbar切换
    if(store.loginNewStore.isLogin){
      this.updateCollaborationClassByViewMode()
      store.appStore.viewerEventEmitter.emit('changeToolBar', 'collaboration')
      window.pdfui.getPDFViewer().then((viewer) => {
        viewer.setEnableShortcutKey(true);
      });
    }else{
      store.collaborationStore.updateIsShowCollaborationSignIn(true)
      this.setCollaborationMode_noSignIn()

      window.pdfui.getPDFViewer().then((viewer) => {
        viewer.setEnableShortcutKey(false);
      });

      if (this.signinReaction) {
        this.signinReaction();
        this.signinReaction = null;
      }
      this.signinReaction = reaction(
        () => store.userStore.hasSignIn,
        (hasSignIn, thisReaction) => {
          if (hasSignIn) {
            window.pdfui.getPDFViewer().then((viewer) => {
              viewer.setEnableShortcutKey(true);
            });
            thisReaction.dispose();
            this.signinReaction = null;
          }
        }
      );
    }
    this.currentMode = COLLABORATION_MODE;
    pdfui.eventEmitter.on(UIExtension.UIEvents.appendCommentListComment, appendCommentListCommentCallback);
    toggleCollaborationMode(true);
    if (!isMobile()) {
      this.setCollaborationHeader()
    }
    if (store.teamsAppStore.loading) {
      store.teamsAppStore.loading.show({progress: 100})
    }

    collaborationAnnotEvent.removeAnnotationListener()
    collaborationAnnotEvent.addAnnotationListener()

    const ruleButton = await pdfui.getComponentByName('toolbar-measure-rulers')
    const ruleGuide = await pdfui.getComponentByName('pdf-viewer-container-with-ruler')

    ruleButton && ruleButton.deactive()
    ruleGuide && ruleGuide.deactive()
    store.collaborationStore.hideSomeFeature()
    store.collaborationStore.addEventListenerForCollaborationMode()
    store.appStore.updatePreventDocModifiedFlag(false)

    const { reviewSessionID } = store.collaborationStore
    const { shareNoticeType } = this.phantomOnlineGlobalConfig

    if (shareNoticeType === 'sns') {
      collaborationAwsSqsService.onMessage({reviewSessionID})
    } else if (emqttUrl) {
      let serverUrl
      let port

      if (window.location.protocol === 'http:') {
        serverUrl = `ws://${emqttUrl}/mqtt`
        // port = emqttWsPort
      } else {
        serverUrl = `wss://${emqttUrl}/mqtt`
        // port = emqttWssPort
      }

      collaborationMqttService.connect({ serverUrl, port })
    }
  }
  @action setCommonMode2(){
    store.appStore.viewerEventEmitter.emit('changeToolBar', 'common')
    this.currentMode = COMMON_MODE
  }
  @action setCommonMode(switchWorkerCallback) {
    collaborationService.showCommonModeSidebar()
    this.currentMode = COMMON_MODE
    toggleCollaborationMode(false);
    this.setCommonHeader()

    localToGlobal.switchWorker().then(() => {
      switchWorkerCallback && switchWorkerCallback()
    })

    store.collaborationStore.showSomeFeature()
    store.collaborationStore.clearActiveAnnot()
    store.collaborationStore.clearAnnotTaskArr()
    store.collaborationStore.removeEventListenerForCollaborationMode()
    store.appStore.viewerEventEmitter.emit('changeToolBar', 'common')

    collaborationAnnotEvent.removeAnnotationListener()
    toggleCollaborationMode(false);

    const { shareNoticeType } = this.phantomOnlineGlobalConfig

    if (shareNoticeType === 'sns') {
      collaborationAwsSqsService.cleanOnMsgInterval()
    } else {
      if (collaborationMqttService.isConnected()) {
        collaborationMqttService.end()
      }
    }

    disableCollaborationOnlyRead()

    if (!store.appStore.isCollaborationMode()) {
      let $$ = window.UIExtension.jQuery
      $$('.fv__ui-commentlist-comment-icon').removeAttr("style").html('');
      $$('.fv__ui-commentlist-comment-avatar').hide()
    }

    this.updateCollaborationModeClassName('')
    pdfui.eventEmitter.removeListener(UIExtension.UIEvents.appendCommentListComment, appendCommentListCommentCallback);
  }
  @action setSaveToLocalComputer(method) {
    this.saveToLocalComputer = method
  }
  @action setOpenLocalFile(method) {
    this.openLocalFile = method
  }
  @action setOnShowToDoDlg(method) {
    this.onShowToDoDlg = method
  }
  @action setOnShowWarningMessage(method) {
    this.onShowWarningMessage = method
  }
  @action setIsDisableButton(method) {
    this.isDisableButton = method
  }
  @action setCommonForSaveDrives(method) {
    this.commonForSaveDrives = method
  }
  @action setDoShowEditorLoading(method) {
    this.doShowEditorLoading = method
  }
  @action setDoHideEditorLoading(method) {
    this.doHideEditorLoading = method
  }
  onShowWarningMessageAsync({
    message,
    iconType = 'warning',
    messageParams,
    title,
    ok,
    cancel,
    noConfirm,
    isI18n,
    zIndex,
    closable,
    checkbox,
    customClose,
    timerFn
  }, noClose) {
    return new Promise((resolve, reject) => {
      try {
        this.onShowWarningMessage(resolve, {
          message,
          iconType,
          messageParams,
          title,
          ok,
          cancel,
          noConfirm,
          isI18n,
          zIndex,
          closable,
          checkbox,
          customClose,
          timerFn
        }, noClose)
      } catch (e) {
        reject(e)
      }
    })
  }
  @action setShowToSaveBeforeOpen(method) {
    this.onShowToSaveBeforeOpen = method
  }
  onShowToSaveBeforeOpenAsync() {
    return new Promise((resolve) => {
      this.onShowToSaveBeforeOpen(resolve).then()
    })
  }
  @action doBlankPDF() {
    const fn = () => {
      pdfui.pdfViewer.createNewDoc()
    }

    this.onShowToSaveBeforeOpen((isToSave) => {
      !isToSave && fn()
    })
  }
  @action async isShowFromTemplate() {
    const { lang } = store.appStore.lng;
    const { isOnPremiseDeployMode } = store.appStore;
    let fromTemplateButton = await pdfui.getComponentByName(CONVERT_FROM_TEMPLATE)
    if (!!fromTemplateButton) {
      const showFormTemplateBtn = (lang === 'en');
      if (showFormTemplateBtn && !isOnPremiseDeployMode) {
        fromTemplateButton.show()
      } else {
        fromTemplateButton.hide()
      }
    }else{
      const root = await pdfui.getRootComponent();
      root.on('lazy-content',(cmp)=>{
        if(cmp.name == 'fv--convert-tab-paddle'){
          this.isShowFromTemplate();
        }
        if(cmp.name == 'fv--file-tab-paddle'){
          if(isCNDomain()){
            root.querySelectorAll('open-file-button-list > @dropdown > @dropdown-button')
            .forEach((cmpt,index)=>{
              if(index>1){
                cmpt.hide()
              }
            })
          }
        }
      })
    }

  }

  // Scanned Document Editing Settings 设置窗口
  @observable ScannedDocumentSetting = {
    visible: false,
  }
  @observable isShowPluginInstall = false;
  @observable isSdkFinishInit = false;

  @observable isShowPwaTips = false;

  @action setShowPluginInstall(val){
    this.isShowPluginInstall = val
  }
  @action setIsSdkFinishInit(val){
    this.isSdkFinishInit = val
  }
  @action showScannedDocumentSetting () {
    this.ScannedDocumentSetting.visible = true;
  }
  @action hideScannedDocumentSetting () {
    this.ScannedDocumentSetting.visible = false;
  }
  @action async doGetUserPluginList() {
    try {
      const { token: userToken } = store.userStore;
      const res = await pluginStoreApi.doGetUserPluginList({ userToken });

      return res;
    } catch (error) {
      throw error;
    }
  }
  @observable securityMode = 'off';
  @action setSecurityMode(mode) {
    this.securityMode = mode;
  }
  @computed get isProtectedView () {
    return this.securityMode === 'all';
  }
  @action setisOnline (val){
    this.isOnline = val
  }
  @action setCloseMessageCenterDlg(method){
    this.closeMessageCenterDlg = method
  }
  @action setAddMessage(method){
    this.addMessage = method
  }
  @action setConvertHtml2PDFFn(method) {
    this.convertHtml2PDFFn = method;
  }
  @action setOnAddCurrentDocForCombineFilesFn(method) {
    this.onAddCurrentDocForCombineFilesFn = method;
  }
  @action setOnAddDocForCombineFilesFn(method) {
    this.onAddDocForCombineFilesFn = method;
  }
  @action setOnCovertFileForPreviewFn(method) {
    this.onCovertFileForPreviewFn = method;
  }
  @action setOnCloseMulFilesDlgFn(method) {
    this.onCloseMulFilesDlgFn = method;
  }
  @action toggleSaveAsDialogCNArea(status) {
    this.showSaveAsDialogCNArea = status;
  }
  // sign china stamp total
  @action setSignChinaStampTotal (isAdd = true) {
    if (isAdd) {
      this.signChinaStampTotal += 1;
    } else {
      this.signChinaStampTotal -= 1;
    }
    if (this.signChinaStampTotal < 0) {
      this.signChinaStampTotal = 0
    }
  }
  @action getVerifySignatureRule() {
    this.initVerifySignatureRule();
    return this.verifySignatureRule;
  }
  @action initVerifySignatureRule() {
    let verifySignatureRule = window.localStorage.getItem('verifySignatureRule');
    let __rule = {
        verifyDocWhenOpened: true,
        untrustedAlterInfo: false,
        is_verify_signature: true,
        use_expired_tst: true,
        ignore_doc_info: false,
        time_type: 0
    };
    try {
      let rule = JSON.parse(verifySignatureRule);
      __rule = [null, undefined].includes(rule) ? __rule : rule;
    } catch (error) {
      __rule = {
        verifyDocWhenOpened: true,
        untrustedAlterInfo: false,
        is_verify_signature: true,
        use_expired_tst: true,
        ignore_doc_info: false,
        time_type: 0
      };
    }
    this.updateVerifySignatureRule(__rule)
  }
  @action updateVerifySignatureRule(rule = {}) {
    this.verifySignatureRule = { ...this.verifySignatureRule, ...rule };
    window.localStorage.setItem('verifySignatureRule', JSON.stringify(this.verifySignatureRule));
  }
  @action getPdfSignConfig() {
    this.initPdfSignConfig();
    return this.pdfSignConfig;
  }
  @action initPdfSignConfig() {
    let pdfSignConfig = window.localStorage.getItem('pdfSignConfig');
    let __config = {
      isDisableFoxitEsignService: false,
      isFlatteDocumentWhenApplyingAllSignatures: false
    };
    try {
      let config = JSON.parse(pdfSignConfig);
      __config = [null, undefined].includes(config) ? __config : config;
    } catch (error) {
      __config = {
        isDisableFoxitEsignService: false,
        isFlatteDocumentWhenApplyingAllSignatures: false
      };
    }
    this.updatePdfSignConfig(__config)
  }
  @action updatePdfSignConfig(config = {}) {
    this.pdfSignConfig = { ...this.pdfSignConfig, ...config };
    window.localStorage.setItem('pdfSignConfig', JSON.stringify(this.pdfSignConfig));
  }
  @action isShowDocFormInfo() {
    this.initShowDocFormInfo();
    return this.showDocFormInfo;
  }
  @action initShowDocFormInfo() {
    let isShowFormInfo = true;
    let isShowFormInfoStr = window.localStorage.getItem('isShowFormInfo');
    try {
      isShowFormInfo = JSON.parse(isShowFormInfoStr);
      isShowFormInfo = [null, undefined].includes(isShowFormInfo) ? true : isShowFormInfo;
    } catch (error) {
      isShowFormInfo = true;
    }
    this.updateShowDocFormInfo(isShowFormInfo);
  }
  @action updateShowDocFormInfo(isShowFormInfo) {
    this.showDocFormInfo = isShowFormInfo;
    window.localStorage.setItem('isShowFormInfo', isShowFormInfo);
  }
  @action onOpenFeedbackPage() {
    if(!window.__online__){
      this.doNotifyErrors('offline');
      return;
    }
    const lang = this.lng.full
    const feedbackWin = windowActionFn(window, 'open', [`/feedback?lang=${lang}`]);
    const onHandleWindowMessage = function(event) {
      const action = event.data.action;

      if (action === 'close') {
        feedbackWin.close();

        window.removeEventListener('message', onHandleWindowMessage, false);
      }
    };

    window.addEventListener('message', onHandleWindowMessage, false);
  }
  @action setIsShowPwaTips(value){
    this.isShowPwaTips =  value
  }
  @action toEsignDocList(){
    this.doDisableMessageCenterDlg()
    this.setHomeHeader()
    this.updateShowHomeStart(true)
    this.setHomeTab('EsignDoc')
  }
  @action doDisableMessageCenterDlg(){
    this.closeMessageCenterDlg()
    this.disableMessageCenterDlg = true
  }
  @action doAbleMessageCenterDlg(){
    this.disableMessageCenterDlg = false
  }
  @action setHomeTab(value){
    this.homeTabActive = value
  }
  // 是否包含Storage服务，中国区、日本区不包含
  @computed get isIncludeFoxitStorage () {
    if (isJPDomain() || isCNDomain()) return false;
    return true;
  }
  @action checkAppSignInForCustoms({btnName = '', isShowDlg = true} = {}) {
    if (isJPDomain()) {
      // 日本区可以免登录使用功能
      return true;
    }
    return this.checkAppSignIn({btnName, isShowDlg});
  }
  @action checkAppSignIn({btnName = '', isShowDlg = true} = {}) {
    if(store.userStore.hasSignIn){
      return true;
    } else {
      if (isShowDlg) {
        this.doShowSignInDialog({btnName})
      }
      return false;
    }
  }

  @action doShowSignInDialog({btnName = '', isFromInitializeOnFirst = false} = {}) {
    // token过期弹出
    if (store.userStore.isTokenExpired) {
      let id = 'Permission.SignIn';
      if (btnName && isForConvert(btnName)) {
        id = 'Permission.SignIn.Convert';
      }
      store.userStore.doSendGAEventByUser({eventKey: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW, label: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL})
      this.doUpdateSignInNotice({id, isFromInitializeOnFirst, isFromTokenExpired: true});
    } else {
      // token没有过期
      store.userStore.popupSignUpOrSignIn = true;
    }
  }

  @action downloadEditorCloudApplication() {
    store.userStore.doSendGAEvent({
      eventKey: INSTALL_BUTTON_PACKAGE_DOWNLOAD,
      label: TOOLS_GA_EVENT_LABEL
    });
    if (this.phantomOnlineGlobalConfig) {
      let url = '';
      let { onlineAppDownloadUrlForWin, onlineAppDownloadUrlForMac } = this.phantomOnlineGlobalConfig;
      if (isWindows) {
        url = onlineAppDownloadUrlForWin;
      } else if (isMac) {
        url = onlineAppDownloadUrlForMac;
      }
      if (url) {
        windowActionFn(window, 'open', [url]);
      }
    }
  }
  /**
    * @type {import ('@/store/AIStore').default}
    */
  aiStore=null
  /**
    * @type {import ('@/api/ai.api')}
    */
  aiModule=null

  // bit 0 :AC 是否控制关闭
  // bit 1 : 用户本身是否关闭
  // 0b10状态也表示关闭，ac关闭高于用户开启
  @observable aiUIFlag = +(localStorage.getItem('aiUIFlag')||'3');
  @action setAIUIFlag(value) {
    this.aiUIFlag = value;

    localStorage.setItem('aiUIFlag',value);

    this.loadAiStore()
    .then(()=>{
        this.aiStore.updateUIX(value);
    })
  }

  loadAiStore(){
    if(this.aiInitialTask)return this.aiInitialTask;

    return this.aiInitialTask = 
            import("Api/ai.api")
            .then(module=>{
                this.aiModule = module;

                return window.pdfui.getComponentByName('sidebar-right-tabs')
                .then(cmp=>{
                    this.aiContainer = cmp.append(`<sidebar-tab-panel class="right-ai-panel" name="right-ai-panel" tab-title="ai.product"></sidebar-tab-panel>`);
                })
                .then(()=>module.default.getUsage())
                .then((res)=>{
                    /**
                    * @type {AIUsage}
                    */
                    this.aiUsage = res.data;

                    if(!this.aiStore){
                        /**
                         * @type {import ('@/store/AIStore').default}
                         */
                        this.aiStore = new this.aiModule.AIStore(this.aiContainer);
                    }
                    return res;
                })
            });
  }

  skipRegionAlert=false;
  @observable aiDialogType='';
  @action showChatAI(type='FirstAITip',hideInfo,skipRegionAlert=false,isOpenFile=false){
    let aiTaskId = this.taskId = Date.now();

    this.aiDialogType="";

    if(this.aiUIFlag<3){
        if(type)
            return;
    }

    if(!(isAISupported())||!window.pdfui){
        return;
    }

    //未登录判断
    if(!store.userStore.hasSignIn&&type=='AiDialog')
    {
        if(!isOpenFile&&!fileController.pdfViewer.getCurrentPDFDoc()&&(this.isFromServiceModeOfClient|| this.sharePointInfo.isFromSharePoint ))
        return;
      return this.doShowSignInDialog();
    }

    baseUrlApis.getServerConfig((config=>{
        let usageTask;
        if(!this.aiUsage&&!this.aiInitialTask){
            usageTask = this.loadAiStore();
        }else{
            usageTask = type.length?this.aiModule.default.getUsage():Promise.resolve({data:{}});
        }

        usageTask.then(res=>{
            /**
            * @type {AIUsage}
            */
            let usage = this.aiUsage = res.data;
            usage.policyStatus=usage.policyStatus||0;
            let {PolicyTypes} = this.aiModule;

            if(aiTaskId != this.taskId)return;

            // 用户所在环境错误
            const isTestEnv = ['online-azk8s.foxitcloud.com/','localhost:3000/'].some(url=>location.href.indexOf(url)!==-1)
            if(!isTestEnv&& NoAICountry.indexOf(config.userCountry)>-1){
                if(type=="AiDialog"){
                    !skipRegionAlert&&window.pdfui.alert({ message: intl.get('GetStartGuid.aiForbidden'), level: 'warning' });
                }
                return;
            }

            // 未初始化
            if(!fileController.pdfViewer){
                return setTimeout(() => {
                    this.showChatAI(type,hideInfo)
                }, 1000);
            }

            // 没有打开文档
            if(type!=''&&fileController.pdfViewer&&!fileController.pdfViewer.getCurrentPDFDoc()){
                this.emitEvent('openFileWithAI');
                this.openAIDialog=1;
                return;
            }

            this.aiStore.initUI();

            let userPolicy = usage.policyStatus;
            if(userPolicy&PolicyTypes.hideFirstTip && type == 'FirstAITip'){
                type = 'CommonOpenTip'
            }

            if(userPolicy&PolicyTypes.hideCommonTip && type == 'CommonOpenTip'){
                type = ''
            }
            if(userPolicy&PolicyTypes.hideSelectionTip && type == 'SelectionTip'){
                type = ''
            }

            let api = this.aiModule.default;
            if(hideInfo){
                if(hideInfo == 1||hideInfo == 16){
                    userPolicy |=2;
                }
                api.setPolicy(this.aiUsage.policyStatus = userPolicy|hideInfo);
            }

            if(this.openAIDialog){
                this.openAIDialog=0;
                type='AiDialog'
            }
            this.aiDialogType=type;

            if(type == "AiDialog"){
                const root = this.aiContainer.getRoot();

                if (!this.aiStore.uiFloating && isAISupported()) {
                    const sidebar = root.getComponentByName('sidebar-right');
                    const tabs = sidebar.getComponentByName('sidebar-right-tabs');
                    if(tabs.openTabs.indexOf('right-ai-panel')==-1){
                        tabs.setActivetab('right-ai-panel');
                        tabs.openTab('right-ai-panel');
                    }
                    sidebar.show();
                }
            }
        })
    }));

  }
  @action setCloudOnlineStorage(data) {
    this.cloudOnlineStorage = data;
    this.emitEvent(APP_CONSTANTS.SWITCH_CLOUD_ONLINE_STORAGE, data);
  }

  setUIConfig(fragments,toolbarTemplate){
    this.uiConfig={
      fragments,
      toolbarTemplate,
    }
  }
  getUIconfig(){
    return this.uiConfig;
  }

  loadLocales({ lang,full },allLangs) {
    if(allLangs)
      this.allLangs = allLangs;
    else{
      allLangs = this.allLangs;
    }

    if(lang in allLangs){
      intl.init({
        currentLocale: lang,
        locales: allLangs,
        fallbackLocale: "en"
      })
      return Promise.resolve(allLangs);
    };

    return fetch("static/js/"+full+"."+i18nHashes[full]+".json")
    .then(res=>res.json())
    .then((intlStrs)=>{
      allLangs[lang]=intlStrs;
      this.allLocales[full] = intlStrs;
      intl.init({
        currentLocale: lang,
        locales: allLangs,
        fallbackLocale: "en"
      })
      return allLangs;
    })
  }

  doAddResourceBundle(pdfui){
    let allLangs = this.allLocales;

    //  zhCN, enUS
    let foxitai_en = allLangs['en-US'];

    for(let key in allLangs){
      let value = allLangs[key];
      pdfui.i18n.addResourceBundle( key, 'phantom_online',
        {
          'Edit':value['Edit'],
          sidebar: value.sidebar,
          toolbar: value.toolbar,
          foxitai: value.AiRecommend? value.AiRecommend.panel:foxitai_en.AiRecommend.panel,
          user:{
            'toAdminConsole':value['user.toAdminConsole'],
            'signIn':value['user.signIn'],
            'signOut':value['user.signOut'],
            'signUp':value['user.signUp'],
            'myAccount': value['user.myAccount'],
            'policy': value['user.policy'],
            'terms': value['user.terms'],
          },
          openServerModeOfClientInSafariErrorTip: value.openServerModeOfClientInSafariErrorTip,
          alertTitle: value['PhantomPDF.Online.TitleWithOnline'],
          paperCheck: value.PaperCheck
        }, true, false );
    }
  }
  doReplaceResourceAfterInit(pdfui, lang, onlyAddon=false){
    let allLangs = this.allLocales;
    for(let key in allLangs){
      let value = allLangs[key];
      if(lang !== key){
        continue;
      }
      let lngValue = pdfui.i18n.getResource(key, 'ui_', "common-dialogs.alert-title");
      let newLngValue = value['PhantomPDF.Online.TitleWithOnline'];

      if(pdfui.addonInstanceMap['RecognitionFormUIXAddon'])
      pdfui.i18n.addResource(key, 'recognition-form', "error.title", newLngValue)
    if(pdfui.addonInstanceMap['XfaFormUIXAddon'])
      pdfui.i18n.addResource(key, 'xfa', "confirm.title", newLngValue)

      if(lngValue === newLngValue){
        break;
      }

      if(onlyAddon)
        continue;
      pdfui.i18n.addResource(key, 'ui_', "common-dialogs.alert-title", newLngValue)
      pdfui.i18n.addResource(key, 'ui_', "common-dialogs.prompt-title", newLngValue)
      pdfui.i18n.addResource(key, 'ui_', "common-dialogs.confirm-title", newLngValue)
      pdfui.i18n.addResource(key, 'ui_', "sidebar.bookmark.confirm.title", newLngValue)
      pdfui.i18n.addResource(key, 'article-module', "confirm.title", newLngValue)
    }
  }
}

export default AppStore;

function toggleCollaborationMode(status) {
  window.pdfui.getPDFViewer().then((viewer) => {
    viewer.toggleCollaborationMode(status);
  })
}
